/* eslint-disable */
import {
	setGroupAPI,
	getGroupsAPI,
	requestToJoinGroupAPI,
	getGroupAPI,
	updateGroupAPI,
	getUsersToInviteAPI,
	getUsersAPI,
	removeGroupAPI,
	getUserGroupsAPI,
	getUserRequestsAPI,
	removeGroupUserAPI,
	inviteUsersToGroupAPI,
	getGroupPostsAPI,
	changeGroupUserRoleAPI,
	leaveGroupAPI,
	acceptRejectUserAPI,
	getGroupRequestsAPI,
	acceptRejectGroupAPI,
	cancelRequestGroupAPI,
} from "@/store/modules/groups/groupsAPI";

import {
	updateGroupState
} from "@/store/modules/groups/groupsHelpers";

const state = {
	groups: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	group: null,
	posts: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	usersToInvite: null,
	users: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	userGroups: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	groupRequests:{
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	userRequests: null,
}

const getters = {
	groups: (state) => {
		return state.groups.data
	},
	meta: (state) => {
		return state.groups.meta
	},
	groupRequests: (state) => {
		return state.groupRequests.data
	},
	groupRequestsMeta: (state) => {
		return state.groupRequests.meta
	},
	group: (state) => {
		return state.group
	},
	groupPosts: (state) => {
		return state.posts.data
	},
	groupPostsMeta: (state) => {
		return state.posts.meta
	},
	usersToInvite: (state) => {
		return state.usersToInvite
	},
	users: (state) => {
		return state.users.data
	},
	usersMeta: (state) => {
		return state.users.meta
	},
	userGroups: (state) => {
		return state.userGroups.data
	},
	userRequests: (state) => {
		return state.userRequests
	},
}

const mutations = {
	appendGroup(state, group) {
		state.groups.data.unshift(group)
	},
	setGroup(state, payload) {
		state.group = payload
	},
	updateGroup(state, payload) {
		state.group = Object.assign(state.group, payload)
	},
	clearGroup(state) {
		state.group = null
		state.users.data = null
		state.users.meta = null
	},
	clearGroups(state) {
		state.groups = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			},
		}
	},
	setGroups(state, payload) {
		if (payload.meta.current_page === 1)
			state.groups.data = payload.data
		else
			state.groups.data = state.groups.data.concat(payload.data)
		state.groups.meta = payload.meta
	},
	setGroupPosts(state, payload) {
		if (payload.meta.current_page === 1)
			state.posts.data = payload.data
		else
			state.posts.data = state.posts.data.concat(payload.data)
		state.posts.meta = payload.meta
	},
	clearGroupPosts(state) {
		state.posts = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			}
		}
	},
	setGroupRequests(state, data) {
		state.groupRequests.data = data.data
		state.groupRequests.meta = data.meta
	},
	setUsersToInvite(state, payload) {
		state.usersToInvite = payload
	},
	clearUsersToInvite(state) {
		state.usersToInvite = null
	},
	setUsers(state, payload) {
		state.users.data = payload.data
		state.users.meta = payload.meta
	},
	clearUsers(state) {
		state.users.data = null
		state.users.meta = null
	},
	setUserGroups(state, payload) {
		state.userGroups = payload
	},
	// removeGroupUser(state, id) {
	// 	let users = state.userGroups
	// 	users.splice(users.findIndex(item => item.id === id), 1)
	// 	state.userGroups = users
	// },
	setUserRequests(state, payload) {
		state.userRequests = payload
	},
	setGroupUser(state, data) {
		let existsAtIndex = state.users.data.findIndex(item => item.id === data.id)
		if (existsAtIndex !== -1) {
			state.users.data[existsAtIndex] = data
		} else {
			state.users.data.push(data)
		}
		existsAtIndex = state.group.admins.findIndex(item => item.id === data.user.id)
		if (data.role === 'moderator' && existsAtIndex === -1) {
			state.group.admins.push(data.user)
		} else if (data.role === 'member' && existsAtIndex !== -1) {
			state.group.admins.splice(existsAtIndex, 1)
		}

		// let user = state.users.find(item => item.user.id === userRequest.user_id)
		// if (userRequest.role === 'moderator')
		// 	state.group.admins.push(user.user)
		// else {
		// 	let index = state.group.admins.findIndex(item => item.id === user.user.id)
		// 	if (index >= 0)
		// 		state.group.admins.splice(index, 1)
		// }
	},
	updateGroupInList(state, data) {
		if (state.groups.data) {
			let existsAtIndex = state.groups.data.findIndex(item => item.id === data.id)
			if (existsAtIndex !== -1)
				state.groups.data[existsAtIndex] = Object.assign(state.groups.data[existsAtIndex], data)
		}
	},
}

const actions = {
	async setGroup({ commit }, { params }) {
		let response = await setGroupAPI(params)
		if (response.success)
			commit('appendGroup', response.data)
		return response.success
	},
	async updateGroup({ commit }, { params }) {
		let response = await updateGroupAPI(params)
		if (response.success)
			commit('updateGroup', response.data)
		return response.success
	},
	async getGroups({ commit }, { params = null }) {
		console.log("GET GROUPS PARAMS", params)
		let response = await getGroupsAPI({ params })
		if (response.success)
			commit('setGroups', response.data)
	},
	async getGroup({ commit, dispatch }, { id }) {
		let response = await getGroupAPI({ id })
		if (response.success) {
			console.log(response.data)
			commit('setGroup', response.data)
			if (response.data.my_role) {
				dispatch('getGroupPosts', { params: null })
			}
			if (response.data.my_role && response.data.my_role !== 'member') {
				dispatch('getGroupRequests', { id })
			}
		}
	},
	async clearGroup({ commit }) {
		commit('clearGroup')
		commit('clearGroupPosts')
	},
	async clearGroups({ commit }) {
		commit('clearGroups')
	},
	async requestToJoinGroup({ commit, dispatch }, { group }) {
		let response = await requestToJoinGroupAPI({ id: group.id})
		if (response.success) {
			updateGroupState({state, dispatch})
			commit('updateGroupInList', response.data.data.group)
		}
	},
	async cancelRequestGroup({ commit, dispatch }, { id }) {
		let response = await cancelRequestGroupAPI({ id })
		if (response.success) {
			console.log('tu się powinny pobrać prośby')
			updateGroupState({state, dispatch})
			commit('updateGroupInList', response.data.group)
			dispatch('getUserRequests')
		}
	},
	async getUsersToInvite({ commit }, { group, params = null }) {
		let response = await getUsersToInviteAPI({id: group.id, params})
		if (response.success)
			commit('setUsersToInvite', response.data)
	},
	async getUsers({ commit, state }, { params = null }) {
		if (!state.group)
			return false
		let response = await getUsersAPI({ id: state.group.id, params })
		if (response.success)
			commit('setUsers', response.data)
	},
	async removeGroup({ commit, state }, { id = null }) {
		if (!id)
			id = state.group.id
		let response = await removeGroupAPI({ id })
		if (response.success)
			commit('clearGroup')
	},
	async removeGroupUser({ commit, rootState, dispatch }, { group_id, user_id = null }) {
		if (!user_id)
			user_id = rootState.auth.user.id
		let response = await removeGroupUserAPI({ group_id, user_id })
		if (response.success)
			updateGroupState({state, dispatch})
		return response.success
	},
	async getUserGroups({ commit, rootState }, { params }) {
		let response = await getUserGroupsAPI({ id: rootState.auth.user.id, params });

		if (response.success) {
			commit('setUserGroups', response.data)
		}
		return response;
	},
	async getUserRequests({ commit }) {
		let response = await getUserRequestsAPI()
		if (response.success)
			commit('setUserRequests', response.data)
	},
	async getGroupPosts({ commit }, { params = null }) {
		let response = await getGroupPostsAPI({ id : state.group.id, params })
		if (response.success)
			commit('setGroupPosts', response.data)
		return response
	},
	async inviteUsersToGroup({ state }, { id, users }) {
		if (!id)
			id = state.group.id
		let response = await inviteUsersToGroupAPI({ id, user_ids: users})
		// if (response.success)
		// 	commit('setUserRequests', response.data)
		return response.success
	},
	async changeGroupUserRole({ commit }, { id, params }) {
		let response = await changeGroupUserRoleAPI({ id, params })
		if (response.success)
			commit('setGroupUser', response.data)
		return response.success
	},
	async leaveGroup({ commit, dispatch }, { id, params }) {
		let response = await leaveGroupAPI({ id, params })
		if (response.success)
			dispatch('getGroup', { id })
		return response.success
	},
	async acceptRejectUser({ commit, dispatch, rootState }, { id, status, user_id = null }) {
		if (!user_id)
			user_id = rootState.auth.user.id
		let response = await acceptRejectUserAPI({ id, status, user_id })
		if (response.success) {
			dispatch('getGroups', {})
			dispatch('getUserRequests')
			dispatch('getGroupRequests', { id })
			dispatch('getUsers', {})
		}
		// return response.success
	},
	async acceptRejectGroup({ commit, dispatch, rootState }, { id, status, user_id = null }) {
		if (!user_id)
			user_id = rootState.auth.user.id
		let response = await acceptRejectGroupAPI({ id, status, user_id })
		if (response.success) {
			// dispatch('getUserRequests')
			dispatch('getGroupRequests', { id })
			dispatch('getUsers', {})
			dispatch('getGroup', { id })
		}
		// return response.success
	},
	async getGroupRequests({ commit, dispatch }, { id, params = null }) {
		let response = await getGroupRequestsAPI({ id, params })
		if (response.success)
			commit('setGroupRequests', response.data)
		// return response.success
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
